import { TIMEZONE_ID } from '@/lib/schedule'

interface CalendarCall {
    id: string
    advisorName: string
    date: string
    time: string
    format: string
    minutes?: number
}

const pad = (value: number): string => String(value).padStart(2, '0')

const stamp = (date: Date): string => `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}Z`

/** Builds an .ics file for a booked call and starts the download. */
export const downloadCallInvite = ({ id, advisorName, date, time, format, minutes = 30 }: CalendarCall): void => {
    const [hour, minute] = time.split(':').map(Number)
    const endTotal = hour * 60 + minute + minutes
    const day = date.replace(/-/g, '')
    const start = `${day}T${pad(hour)}${pad(minute)}00`
    const end = `${day}T${pad(Math.floor(endTotal / 60) % 24)}${pad(endTotal % 60)}00`

    const content = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Verdane//Advisor calls//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:${id}@verdane`,
        `DTSTAMP:${stamp(new Date())}`,
        `DTSTART;TZID=${TIMEZONE_ID}:${start}`,
        `DTEND;TZID=${TIMEZONE_ID}:${end}`,
        `SUMMARY:Verdane call with ${advisorName}`,
        `DESCRIPTION:${format} call with your Verdane advisor. Your advisor will be in touch with the details.`,
        'END:VEVENT',
        'END:VCALENDAR'
    ].join('\r\n')

    const url = URL.createObjectURL(new Blob([content], { type: 'text/calendar;charset=utf-8' }))
    const link = document.createElement('a')

    link.href = url
    link.download = `verdane-call-${date}.ics`
    document.body.appendChild(link)
    link.click()
    link.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
}
